import { translationKey } from '@change-corgi/core/i18n';

export function getPrivacyNoticeTranslationKey(
	shareInfoWithOrganizationVisible: boolean,
	gdpr: boolean,
): ReturnType<typeof translationKey> {
	if (shareInfoWithOrganizationVisible) {
		return translationKey('fe.components.petition_sign.privacy_notice_npo');
	}

	if (gdpr) {
		return translationKey('fe.components.petition_sign.privacy_notice_eu');
	}

	return translationKey('fe.components.petition_sign.privacy_notice');
}
